import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "./baseQuery";

// Dummy API (JSONPlaceholder)
const apiUrl = process.env.REACT_APP_API_URL;
export const filterApi = createApi({
  reducerPath: "filterApi", // optional, defaults to 'api'
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    useGetFancyDimonds: builder.query({
      query: () => "inventory/fancy-colors", // GET /posts
    }),
    useGetCountryList: builder.query({
      query: () => "inventory/locations", // GET /posts
    }),
    getDimonList: builder.mutation({
      query: (filter) => {
        return {
          url: "/inventory/search",
          body: filter,
          method: "post",
        };
      },
    }),
    getDimondDetails: builder.query({
      query: (id) => {
        return {
          url: `/inventory/item/details?inventoryId=${id}`,
          method: "GET",
        };
      },
      transformResponse: (res) => {
        return res.data;
      },
    }),
    //  getDimonList: builder.mutation({
    //   query: (filter) => {
    //     return {
    //       url: "/inventory/search",
    //       body: filter,
    //       method: "post",
    //     };
    //   },
    // }),
  }),
});

export const {
  useUseGetFancyDimondsQuery,
  useUseGetCountryListQuery,
  useGetDimonListMutation,
  useGetDimondDetailsQuery,
} = filterApi;
